import * as React from 'react';

import * as styles from './index.css';

export interface IRatingProps {
  rating: number;
}

/**
 * Создаем массив длинной 5, чтобы вывести 5 звезд в цикле.
 */
const MAX_STAR = new Array(5).fill(0);

export class Rating extends React.Component<IRatingProps, {}> {
  public render() {
    let { rating } = this.props;

    return (
      <div className={styles['container']}>
        {
          MAX_STAR.map((star, index) => {
            let starView;

            if (rating >= 2) {
              starView = <span key={`star_${index}`} className={styles['star_full']}></span>;
            } else if (rating >= 1) {
              starView = <span key={`star_${index}`} className={styles['star_half']}></span>;
            } else {
              starView = <span key={`star_${index}`} className={styles['star_empty']}></span>;
            }

            rating -= 2;

            return starView;
          })
        }
      </div>
    );
  }
}
